module.exports = __webpack_public_path__ + "img/horizontal_4_1_r_6000.9a030a2e.png";